import { render } from "./MessagesSystemGroup.vue?vue&type=template&id=27a1a4de&scoped=true"
import script from "./MessagesSystemGroup.vue?vue&type=script&lang=js"
export * from "./MessagesSystemGroup.vue?vue&type=script&lang=js"

import "./MessagesSystemGroup.vue?vue&type=style&index=0&id=27a1a4de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a1a4de"]])

export default __exports__